import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  monthContainer: css`
    width: 100%;
    height: 139px;
    position: relative;
  `,
  parallax: css`
    background-attachment: fixed;
    min-height: 100px;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
  `,
  monthName: css`
    color: ${colors.prussian};
    font-size: 18px;
    font-weight: 700;
    text-transform: capitalize;
    margin-top: 16px;
    margin-bottom: 8px;
    position: absolute;
    top: 10px;
    left: 70px;
  `,
  month: css`
    position: sticky;
    z-index: 9;
    text-transform: capitalize;
    color: ${colors.prussian};
    font-size: 18px;
    font-weight: 700;
    transition: top 0.2s ease-out;
    background: ${colors.white};
    padding: 0px 16px 8px 16px;
  `,
  calendar: css`
    margin-bottom: 40px;
    position: relative;
    padding: 0px 16px 0px 16px;
  `,

  monthIllustration: css`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 0% 50%;
  `,
  weekName: css`
    position: sticky;
    z-index: 1;
    color: ${colors.slate};
    font-size: 14px;
    padding-bottom: 16px;
    transition: top 0.2s ease-out;
    background: ${colors.white};
  `,
};

export default styles;
